import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	helpMessage: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-message',
		defaultMessage: 'Can’t find a field?',
		description:
			"Help message shown for users who can't find fields they're expecting to see on the page.",
	},
	findGlobalField: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.find-global-field',
		defaultMessage: 'Need to add a global field?',
		description:
			"Help message shown for users who can't find fields they're expecting to see on the page.",
	},
	helpLink: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-link',
		defaultMessage: 'Go to custom fields',
		description:
			'Text shown for a link button that allows users to create new fields in Jira system settings',
	},
	helpLinkToFieldsPage: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.help-link-to-fields-page',
		defaultMessage: 'Go to the Fields page',
		description:
			'Text shown for a link button that allows users to create new fields in Project settings > Fields page',
	},
	contactAdminLink: {
		id: 'project-settings-apps-issue-type-page-product-features.common.sidebar.find-field-help-link.contact-admin-link',
		defaultMessage: 'Contact your Jira admin',
		description:
			'Text shown for a link button that allows users to contact their Jira administrator.',
	},
});
